import React from "react";
import { Color } from "./colors";

export const homeSelectedIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/Interface-Essential-Home-house-chimney-2-selected">
      <g id="Group">
        <g id="house-chimney-2">
          <path
            id="Union"
            d="M10.4137 1.70363C11.2924 0.825271 12.7166 0.825271 13.5952 1.70363L15.8015 3.90985C15.9081 3.62546 16.1824 3.42303 16.504 3.42303H20.254C20.6682 3.42303 21.004 3.75882 21.004 4.17303V9.11238L23.7843 11.8927C23.9988 12.1072 24.063 12.4298 23.9469 12.7101C23.8308 12.9903 23.5573 13.173 23.254 13.173H21.004V22.173C21.004 22.5872 20.6682 22.923 20.254 22.923H14.254C13.8398 22.923 13.504 22.5872 13.504 22.173V16.173C13.504 15.7588 13.1682 15.423 12.754 15.423H11.254C10.8398 15.423 10.504 15.7588 10.504 16.173V22.173C10.504 22.5872 10.1682 22.923 9.75399 22.923H3.75399C3.33978 22.923 3.00399 22.5872 3.00399 22.173V13.173H0.753989C0.450636 13.173 0.177154 12.9903 0.0610725 12.71C-0.0550089 12.4298 0.00917137 12.1072 0.223685 11.8927L10.4137 1.70363Z"
            fill="#087BC4"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const homeIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/house-chimney-2">
      <g id="Group">
        <g id="house-chimney-2">
          <path
            id="Shape"
            d="M3.75403 13.923V22.173H9.75403V16.173C9.75403 15.3446 10.4256 14.673 11.254 14.673H12.754C13.5825 14.673 14.254 15.3446 14.254 16.173V22.173H20.254V13.923"
            stroke={Color.secondary50}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_2"
            d="M0.754028 12.423L10.944 2.23401C11.5298 1.64844 12.4793 1.64844 13.065 2.23401L23.254 12.423"
            stroke={Color.secondary50}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_3"
            d="M16.504 5.673V4.173H20.254V9.423"
            stroke={Color.secondary50}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const groupIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.482 8.23425C3.41676 8.21285 3.37197 8.1551 3.36933 8.08897C3.36715 8.02267 3.40731 7.96181 3.47067 7.93537C4.40676 7.55328 4.93334 6.59142 4.73025 5.63458C4.52715 4.67774 3.65052 3.99036 2.63333 3.99036C1.61614 3.99036 0.739512 4.67774 0.536421 5.63458C0.33333 6.59142 0.859907 7.55328 1.796 7.93537C1.85972 7.96123 1.90017 8.02219 1.89765 8.08856C1.89514 8.15492 1.85018 8.2129 1.78467 8.23425C0.71861 8.58431 0.00169998 9.54558 0 10.6272V12.5235C0 12.6981 0.147448 12.8397 0.329333 12.8397H0.916667C1.00252 12.8397 1.07406 12.9028 1.08133 12.985L1.318 15.7107C1.33223 15.8744 1.4749 16.0002 1.646 16H3.62133C3.79218 15.9999 3.93446 15.8742 3.94867 15.7107L4.186 12.985C4.19294 12.9029 4.26428 12.8397 4.35 12.8397H4.938C5.02528 12.8397 5.10898 12.8064 5.17064 12.747C5.23229 12.6877 5.26684 12.6073 5.26667 12.5235V10.6272C5.26537 9.54545 4.54831 8.58398 3.482 8.23425Z"
      fill={Color.secondary70}
    />
    <path
      d="M14.2153 8.23425C14.1498 8.2129 14.1049 8.15492 14.1024 8.08856C14.0998 8.02219 14.1403 7.96123 14.204 7.93537C15.1401 7.55328 15.6667 6.59142 15.4636 5.63458C15.2605 4.67774 14.3839 3.99036 13.3667 3.99036C12.3495 3.99036 11.4729 4.67774 11.2698 5.63458C11.0667 6.59142 11.5932 7.55328 12.5293 7.93537C12.593 7.96135 12.6333 8.0224 12.6307 8.08878C12.628 8.15515 12.5829 8.21304 12.5173 8.23425C11.4514 8.58437 10.7347 9.54568 10.7333 10.6272V12.5235C10.7332 12.6073 10.7677 12.6877 10.8294 12.747C10.891 12.8064 10.9747 12.8397 11.062 12.8397H11.65C11.7357 12.8397 11.8071 12.9029 11.814 12.985L12.0513 15.7107C12.0655 15.8742 12.2078 15.9999 12.3787 16H14.354C14.5251 16.0002 14.6678 15.8744 14.682 15.7107L14.9187 12.985C14.9259 12.9028 14.9975 12.8397 15.0833 12.8397H15.6707C15.8526 12.8397 16 12.6981 16 12.5235V10.6272C15.9983 9.54558 15.2814 8.58431 14.2153 8.23425Z"
      fill={Color.secondary70}
    />
    <path
      d="M8.78201 4.24705C8.71829 4.22542 8.67459 4.16887 8.67152 4.10406C8.66844 4.03924 8.7066 3.97911 8.76801 3.95201C9.53688 3.60703 9.95297 2.79567 9.76892 2.00031C9.58486 1.20495 8.85004 0.639038 8.00134 0.639038C7.15264 0.639038 6.41783 1.20495 6.23377 2.00031C6.04971 2.79567 6.46581 3.60703 7.23468 3.95201C7.29608 3.97911 7.33425 4.03924 7.33117 4.10406C7.3281 4.16887 7.2844 4.22542 7.22068 4.24705C6.3069 4.56346 5.69719 5.39515 5.69534 6.32769V7.27681C5.6975 7.45056 5.84369 7.5909 6.02468 7.59297H6.57068C6.65453 7.59252 6.72511 7.65309 6.73401 7.73313L7.01401 10.1568C7.03268 10.3168 7.17363 10.4378 7.34134 10.4378H8.65868C8.82625 10.4378 8.96699 10.3167 8.98534 10.1568L9.26601 7.73313C9.27552 7.65313 9.34614 7.59278 9.43001 7.59297H9.97534C10.1572 7.59297 10.3047 7.45142 10.3047 7.27681V6.32705C10.3034 5.39528 9.69476 4.56392 8.78201 4.24705Z"
      fill={Color.secondary70}
    />
    <path
      d="M3.482 8.23425C3.41676 8.21285 3.37197 8.1551 3.36933 8.08897C3.36715 8.02267 3.40731 7.96181 3.47067 7.93537C4.40676 7.55328 4.93334 6.59142 4.73025 5.63458C4.52715 4.67774 3.65052 3.99036 2.63333 3.99036C1.61614 3.99036 0.739512 4.67774 0.536421 5.63458C0.33333 6.59142 0.859907 7.55328 1.796 7.93537C1.85972 7.96123 1.90017 8.02219 1.89765 8.08856C1.89514 8.15492 1.85018 8.2129 1.78467 8.23425C0.71861 8.58431 0.00169998 9.54558 0 10.6272V12.5235C0 12.6981 0.147448 12.8397 0.329333 12.8397H0.916667C1.00252 12.8397 1.07406 12.9028 1.08133 12.985L1.318 15.7107C1.33223 15.8744 1.4749 16.0002 1.646 16H3.62133C3.79218 15.9999 3.93446 15.8742 3.94867 15.7107L4.186 12.985C4.19294 12.9029 4.26428 12.8397 4.35 12.8397H4.938C5.02528 12.8397 5.10898 12.8064 5.17064 12.747C5.23229 12.6877 5.26684 12.6073 5.26667 12.5235V10.6272C5.26537 9.54545 4.54831 8.58398 3.482 8.23425Z"
      fill={Color.secondary70}
    />
    <path
      d="M14.2153 8.23425C14.1498 8.2129 14.1049 8.15492 14.1024 8.08856C14.0998 8.02219 14.1403 7.96123 14.204 7.93537C15.1401 7.55328 15.6667 6.59142 15.4636 5.63458C15.2605 4.67774 14.3839 3.99036 13.3667 3.99036C12.3495 3.99036 11.4729 4.67774 11.2698 5.63458C11.0667 6.59142 11.5932 7.55328 12.5293 7.93537C12.593 7.96135 12.6333 8.0224 12.6307 8.08878C12.628 8.15515 12.5829 8.21304 12.5173 8.23425C11.4514 8.58437 10.7347 9.54568 10.7333 10.6272V12.5235C10.7332 12.6073 10.7677 12.6877 10.8294 12.747C10.891 12.8064 10.9747 12.8397 11.062 12.8397H11.65C11.7357 12.8397 11.8071 12.9029 11.814 12.985L12.0513 15.7107C12.0655 15.8742 12.2078 15.9999 12.3787 16H14.354C14.5251 16.0002 14.6678 15.8744 14.682 15.7107L14.9187 12.985C14.9259 12.9028 14.9975 12.8397 15.0833 12.8397H15.6707C15.8526 12.8397 16 12.6981 16 12.5235V10.6272C15.9983 9.54558 15.2814 8.58431 14.2153 8.23425Z"
      fill={Color.secondary70}
    />
    <path
      d="M8.78201 4.24705C8.71829 4.22542 8.67459 4.16887 8.67152 4.10406C8.66844 4.03924 8.7066 3.97911 8.76801 3.95201C9.53688 3.60703 9.95297 2.79567 9.76892 2.00031C9.58486 1.20495 8.85004 0.639038 8.00134 0.639038C7.15264 0.639038 6.41783 1.20495 6.23377 2.00031C6.04971 2.79567 6.46581 3.60703 7.23468 3.95201C7.29608 3.97911 7.33425 4.03924 7.33117 4.10406C7.3281 4.16887 7.2844 4.22542 7.22068 4.24705C6.3069 4.56346 5.69719 5.39515 5.69534 6.32769V7.27681C5.6975 7.45056 5.84369 7.5909 6.02468 7.59297H6.57068C6.65453 7.59252 6.72511 7.65309 6.73401 7.73313L7.01401 10.1568C7.03268 10.3168 7.17363 10.4378 7.34134 10.4378H8.65868C8.82625 10.4378 8.96699 10.3167 8.98534 10.1568L9.26601 7.73313C9.27552 7.65313 9.34614 7.59278 9.43001 7.59297H9.97534C10.1572 7.59297 10.3047 7.45142 10.3047 7.27681V6.32705C10.3034 5.39528 9.69476 4.56392 8.78201 4.24705Z"
      fill={Color.secondary70}
    />
  </svg>
);

export const messageSelectedIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/Messages-Chat-Smileys-Messages-Speech-Bubbles-messages-bubble-typing-1-selected">
      <g id="Group">
        <g id="messages-bubble-typing_1">
          <path
            id="Subtract"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.378 7.50491C21.7878 3.00055 17.5265 -0.00844416 12.7498 -1.28443e-05C8.66706 -0.00544992 4.90264 2.20442 2.91742 5.77212C0.999468 9.21892 1.0339 13.4088 2.98337 16.8148L0.0728318 22.9276C-0.0636759 23.2143 -0.00484338 23.5559 0.21971 23.7804C0.444263 24.0049 0.785866 24.0636 1.07254 23.9271L7.18435 21.0156C11.1858 23.3055 16.2003 22.9251 19.8162 20.0198C23.5402 17.0275 24.9683 12.0097 23.378 7.50491ZM8.25 10.125C7.62868 10.125 7.125 10.6286 7.125 11.25C7.125 11.8713 7.62868 12.375 8.25 12.375C8.87132 12.375 9.375 11.8713 9.375 11.25C9.375 10.6286 8.87132 10.125 8.25 10.125ZM11.625 11.25C11.625 10.6286 12.1287 10.125 12.75 10.125C13.3713 10.125 13.875 10.6286 13.875 11.25C13.875 11.8713 13.3713 12.375 12.75 12.375C12.1287 12.375 11.625 11.8713 11.625 11.25ZM17.25 10.125C16.6287 10.125 16.125 10.6286 16.125 11.25C16.125 11.8713 16.6287 12.375 17.25 12.375C17.8713 12.375 18.375 11.8713 18.375 11.25C18.375 10.6286 17.8713 10.125 17.25 10.125Z"
            fill="#087BC4"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const MessageIcon: React.FC<{ color?: Color }> = ({ color = Color.primary }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/Messages-Chat-Smileys-Messages-Speech-Bubbles-messages-bubble-typing-1">
      <g id="Group">
        <g id="messages-bubble-typing_1">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.75 0.749988C8.93933 0.744494 5.42568 2.80692 3.5728 6.1368C1.71991 9.46667 1.81953 13.5397 3.833 16.775L0.75 23.25L7.224 20.166C11.0101 22.5209 15.8706 22.2279 19.3464 19.4351C22.8222 16.6424 24.1551 11.959 22.6708 7.75458C21.1865 3.55015 17.2087 0.741629 12.75 0.749988Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_2"
            d="M8.25 10.875C8.04289 10.875 7.875 11.0429 7.875 11.25C7.875 11.4571 8.04289 11.625 8.25 11.625C8.45711 11.625 8.625 11.4571 8.625 11.25C8.625 11.0429 8.45711 10.875 8.25 10.875"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_3"
            d="M12.75 10.875C12.5429 10.875 12.375 11.0429 12.375 11.25C12.375 11.4571 12.5429 11.625 12.75 11.625C12.9571 11.625 13.125 11.4571 13.125 11.25C13.125 11.0429 12.9571 10.875 12.75 10.875"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_4"
            d="M17.25 10.875C17.0429 10.875 16.875 11.0429 16.875 11.25C16.875 11.4571 17.0429 11.625 17.25 11.625C17.4571 11.625 17.625 11.4571 17.625 11.25C17.625 11.0429 17.4571 10.875 17.25 10.875"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const arrowRightIcon = (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 15.8974L2.51279 18L11 9L2.51279 3.70988e-07L0.499999 2.10264L6.97442 9L0.5 15.8974Z"
      fill="#767B84"
    />
  </svg>
);

export const questionCircleIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 8.99999C9.00029 7.47442 10.1455 6.192 11.6613 6.01975C13.1771 5.84749 14.5808 6.84027 14.9234 8.32687C15.266 9.81348 14.4383 11.3205 13 11.829C12.4004 12.041 11.9997 12.608 12 13.244V14.25"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17.25C11.7929 17.25 11.625 17.4179 11.625 17.625C11.625 17.8321 11.7929 18 12 18C12.2071 18 12.375 17.8321 12.375 17.625C12.375 17.4179 12.2071 17.25 12 17.25V17.25"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
    />
  </svg>
);

export const arrowLeftIcon = (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 2.10264L8.48721 -1.11296e-06L1.18021e-06 9L8.48721 18L10.5 15.8974L4.02558 9L10.5 2.10264Z"
      fill="white"
    />
  </svg>
);

export const preferencesIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/preferences">
      <g id="Group">
        <g id="cog">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.546 2.43799C10.9171 2.84994 11.4455 3.08513 12 3.08513C12.5545 3.08513 13.0829 2.84994 13.454 2.43799L14.4 1.39999C14.9556 0.785137 15.8379 0.586353 16.6035 0.903575C17.369 1.2208 17.8521 1.98539 17.81 2.81299L17.739 4.21299C17.7112 4.76527 17.9183 5.30353 18.309 5.69483C18.6997 6.08612 19.2377 6.29396 19.79 6.26699L21.19 6.19599C22.017 6.15522 22.7804 6.63885 23.0968 7.40406C23.4132 8.16927 23.2143 9.05078 22.6 9.606L21.558 10.546C21.1466 10.9176 20.9118 11.4461 20.9118 12.0005C20.9118 12.5549 21.1466 13.0834 21.558 13.455L22.6 14.395C23.2149 14.9506 23.4136 15.8329 23.0964 16.5984C22.7792 17.364 22.0146 17.8471 21.187 17.805L19.787 17.734C19.2335 17.7055 18.6938 17.913 18.3019 18.3049C17.91 18.6968 17.7025 19.2365 17.731 19.79L17.802 21.19C17.8387 22.0132 17.3563 22.7714 16.595 23.0869C15.8337 23.4024 14.9564 23.2078 14.4 22.6L13.459 21.559C13.0876 21.1476 12.5593 20.9128 12.005 20.9128C11.4507 20.9128 10.9224 21.1476 10.551 21.559L9.606 22.6C9.0504 23.2107 8.17154 23.4075 7.40854 23.0921C6.64554 22.7767 6.1622 22.0168 6.2 21.192L6.272 19.792C6.30047 19.2385 6.09302 18.6988 5.7011 18.3069C5.30918 17.915 4.76952 17.7075 4.216 17.736L2.816 17.807C1.98873 17.8502 1.22381 17.3681 0.905883 16.6031C0.587955 15.8382 0.785828 14.9559 1.4 14.4L2.441 13.46C2.85242 13.0884 3.08722 12.5599 3.08722 12.0055C3.08722 11.4511 2.85242 10.9226 2.441 10.551L1.4 9.606C0.787888 9.05074 0.590308 8.17095 0.906222 7.40729C1.22214 6.64362 1.98351 6.16054 2.809 6.2L4.209 6.27099C4.76359 6.30015 5.30448 6.09243 5.69699 5.69954C6.0895 5.30665 6.2967 4.76556 6.267 4.21099L6.2 2.80999C6.16129 1.98486 6.64431 1.22411 7.40754 0.908158C8.17076 0.592202 9.05017 0.788941 9.606 1.39999L10.546 2.43799Z"
            stroke={Color.secondary50}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Oval"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 16.501C14.4853 16.501 16.5 14.4863 16.5 12.001C16.5 9.51573 14.4853 7.50101 12 7.50101C9.51472 7.50101 7.5 9.51573 7.5 12.001C7.5 14.4863 9.51472 16.501 12 16.501Z"
            stroke={Color.secondary50}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const preferencesSelectedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="24/preferences-selected">
      <g id="Group">
        <g id="cog">
          <g id="Subtract">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3.08513C11.4455 3.08513 10.9171 2.84994 10.546 2.43799L9.606 1.39999C9.05017 0.788941 8.17076 0.592202 7.40754 0.908158C6.64431 1.22411 6.16129 1.98486 6.2 2.80999L6.267 4.21099C6.2967 4.76556 6.0895 5.30665 5.69699 5.69954C5.30448 6.09243 4.76359 6.30015 4.209 6.27099L2.809 6.2C1.98351 6.16054 1.22214 6.64362 0.906222 7.40729C0.590308 8.17095 0.787888 9.05074 1.4 9.606L2.441 10.551C2.85242 10.9226 3.08722 11.4511 3.08722 12.0055C3.08722 12.5599 2.85242 13.0884 2.441 13.46L1.4 14.4C0.785828 14.9559 0.587955 15.8382 0.905883 16.6031C1.22381 17.3681 1.98873 17.8502 2.816 17.807L4.216 17.736C4.76952 17.7075 5.30918 17.915 5.7011 18.3069C6.09302 18.6988 6.30047 19.2385 6.272 19.792L6.2 21.192C6.1622 22.0168 6.64554 22.7767 7.40854 23.0921C8.17154 23.4075 9.0504 23.2107 9.606 22.6L10.551 21.559C10.9224 21.1476 11.4507 20.9128 12.005 20.9128C12.5593 20.9128 13.0876 21.1476 13.459 21.559L14.4 22.6C14.9564 23.2078 15.8337 23.4024 16.595 23.0869C17.3563 22.7714 17.8387 22.0132 17.802 21.19L17.731 19.79C17.7025 19.2365 17.91 18.6968 18.3019 18.3049C18.6938 17.913 19.2335 17.7055 19.787 17.734L21.187 17.805C22.0146 17.8471 22.7792 17.364 23.0964 16.5984C23.4136 15.8329 23.2149 14.9506 22.6 14.395L21.558 13.455C21.1466 13.0834 20.9118 12.5549 20.9118 12.0005C20.9118 11.4461 21.1466 10.9176 21.558 10.546L22.6 9.606C23.2143 9.05078 23.4132 8.16927 23.0968 7.40406C22.7804 6.63885 22.017 6.15522 21.19 6.19599L19.79 6.26699C19.2377 6.29396 18.6997 6.08612 18.309 5.69483C17.9183 5.30353 17.7112 4.76527 17.739 4.21299L17.81 2.81299C17.8521 1.98539 17.369 1.2208 16.6035 0.903575C15.8379 0.586353 14.9556 0.785137 14.4 1.39999L13.454 2.43799C13.0829 2.84994 12.5545 3.08513 12 3.08513ZM16.5 12.001C16.5 14.4863 14.4853 16.501 12 16.501C9.51472 16.501 7.5 14.4863 7.5 12.001C7.5 9.5157 9.51472 7.50098 12 7.50098C14.4853 7.50098 16.5 9.5157 16.5 12.001Z"
              fill="#087BC4"
            />
            <path
              d="M10.546 2.43799L11.1032 1.936L11.1019 1.93456L10.546 2.43799ZM9.606 1.39999L10.1619 0.896556L10.1608 0.895326L9.606 1.39999ZM6.2 2.80999L5.45082 2.84514L5.45086 2.84582L6.2 2.80999ZM6.267 4.21099L5.51784 4.24682L5.51807 4.2511L6.267 4.21099ZM4.209 6.27099L4.24838 5.52203L4.24699 5.52196L4.209 6.27099ZM2.809 6.2L2.84699 5.45095L2.84481 5.45085L2.809 6.2ZM0.906222 7.40729L1.59926 7.69399L0.906222 7.40729ZM1.4 9.606L1.90411 9.05068L1.9039 9.05049L1.4 9.606ZM2.441 10.551L1.93689 11.1063L1.93828 11.1076L2.441 10.551ZM2.441 13.46L2.94364 14.0166L2.94372 14.0166L2.441 13.46ZM1.4 14.4L0.897361 13.8433L0.896703 13.8439L1.4 14.4ZM2.816 17.807L2.77801 17.058L2.77691 17.058L2.816 17.807ZM4.216 17.736L4.25399 18.485L4.25453 18.485L4.216 17.736ZM6.272 19.792L5.52299 19.7535L5.52299 19.7535L6.272 19.792ZM6.2 21.192L5.45098 21.1535L5.45079 21.1577L6.2 21.192ZM9.606 22.6L10.1608 23.1047L10.1613 23.1041L9.606 22.6ZM10.551 21.559L11.1063 22.0631L11.1077 22.0616L10.551 21.559ZM13.459 21.559L12.9023 22.0616L12.9026 22.0619L13.459 21.559ZM14.4 22.6L13.8436 23.1029L13.8468 23.1064L14.4 22.6ZM17.802 21.19L18.5513 21.1566L18.551 21.152L17.802 21.19ZM17.731 19.79L18.48 19.752L18.48 19.7515L17.731 19.79ZM19.787 17.734L19.7485 18.483L19.749 18.483L19.787 17.734ZM21.187 17.805L21.2251 17.056L21.225 17.056L21.187 17.805ZM22.6 14.395L23.1028 13.8385L23.1024 13.8381L22.6 14.395ZM21.558 13.455L21.0553 14.0116L21.0556 14.0119L21.558 13.455ZM21.558 10.546L21.0556 9.98911L21.0553 9.98943L21.558 10.546ZM22.6 9.606L23.1024 10.1629L23.1029 10.1624L22.6 9.606ZM21.19 6.19599L21.1531 5.4469L21.152 5.44696L21.19 6.19599ZM19.79 6.26699L19.8266 7.0161L19.828 7.01603L19.79 6.26699ZM17.739 4.21299L16.99 4.17501L16.9899 4.17533L17.739 4.21299ZM17.81 2.81299L17.061 2.77485L17.061 2.77501L17.81 2.81299ZM16.6035 0.903575L16.8906 0.210704V0.210703L16.6035 0.903575ZM14.4 1.39999L14.9543 1.90519L14.9565 1.90281L14.4 1.39999ZM13.454 2.43799L12.8997 1.93279L12.8968 1.936L13.454 2.43799ZM9.98877 2.93999C10.5021 3.50981 11.2331 3.83513 12 3.83513V2.33513C11.658 2.33513 11.3321 2.19008 11.1032 1.936L9.98877 2.93999ZM9.05008 1.90343L9.99008 2.94143L11.1019 1.93456L10.1619 0.896557L9.05008 1.90343ZM7.69441 1.60113C8.16544 1.40613 8.70816 1.52755 9.05119 1.90466L10.1608 0.895326C9.39217 0.0503308 8.17609 -0.22173 7.12067 0.21519L7.69441 1.60113ZM6.94918 2.77485C6.92529 2.26562 7.22339 1.79612 7.69441 1.60113L7.12067 0.21519C6.06524 0.652109 5.39729 1.70411 5.45082 2.84514L6.94918 2.77485ZM7.01614 4.17517L6.94914 2.77417L5.45086 2.84582L5.51786 4.24682L7.01614 4.17517ZM6.22758 6.22961C6.77043 5.68623 7.057 4.93788 7.01593 4.17089L5.51807 4.2511C5.5364 4.59324 5.40856 4.92707 5.1664 5.16947L6.22758 6.22961ZM4.16962 7.01996C4.93665 7.06029 5.68472 6.77299 6.22758 6.22961L5.1664 5.16947C4.92424 5.41186 4.59054 5.54002 4.24838 5.52203L4.16962 7.01996ZM2.77101 6.94903L4.17101 7.02003L4.24699 5.52196L2.84699 5.45096L2.77101 6.94903ZM1.59926 7.69399C1.79417 7.22284 2.2639 6.9248 2.77319 6.94914L2.84481 5.45085C1.70312 5.39628 0.650106 6.06441 0.213182 7.12059L1.59926 7.69399ZM1.9039 9.05049C1.52626 8.70793 1.40436 8.16513 1.59926 7.69399L0.213182 7.12059C-0.223741 8.17677 0.0495212 9.39356 0.896099 10.1615L1.9039 9.05049ZM2.94511 9.99568L1.90411 9.05068L0.895894 10.1613L1.93689 11.1063L2.94511 9.99568ZM3.83722 12.0055C3.83722 11.2389 3.51258 10.5082 2.94372 9.99443L1.93828 11.1076C2.19227 11.337 2.33722 11.6632 2.33722 12.0055H3.83722ZM2.94372 14.0166C3.51258 13.5027 3.83722 12.772 3.83722 12.0055H2.33722C2.33722 12.3478 2.19227 12.674 1.93828 12.9034L2.94372 14.0166ZM1.90264 14.9566L2.94364 14.0166L1.93836 12.9033L0.897361 13.8433L1.90264 14.9566ZM1.59845 16.3153C1.4023 15.8433 1.52438 15.299 1.9033 14.956L0.896703 13.8439C0.047276 14.6128 -0.226391 15.833 0.213317 16.891L1.59845 16.3153ZM2.77691 17.058C2.26652 17.0847 1.7946 16.7872 1.59845 16.3153L0.213317 16.891C0.653025 17.9489 1.71094 18.6157 2.85509 18.556L2.77691 17.058ZM4.17801 16.987L2.77801 17.058L2.85399 18.556L4.25399 18.485L4.17801 16.987ZM6.23143 17.7766C5.68939 17.2345 4.94302 16.9476 4.17747 16.987L4.25453 18.485C4.59603 18.4674 4.92897 18.5954 5.17077 18.8372L6.23143 17.7766ZM7.02101 19.8305C7.06039 19.065 6.77347 18.3186 6.23143 17.7766L5.17077 18.8372C5.41257 19.079 5.54056 19.412 5.52299 19.7535L7.02101 19.8305ZM6.94901 21.2305L7.02101 19.8305L5.52299 19.7535L5.45099 21.1535L6.94901 21.2305ZM7.69507 22.399C7.22418 22.2043 6.92588 21.7353 6.94921 21.2263L5.45079 21.1577C5.39851 22.2982 6.06691 23.349 7.12202 23.7852L7.69507 22.399ZM9.05123 22.0953C8.70834 22.4722 8.16596 22.5936 7.69507 22.399L7.12202 23.7852C8.17713 24.2214 9.39246 23.9492 10.1608 23.1047L9.05123 22.0953ZM9.99568 21.0549L9.05068 22.0959L10.1613 23.1041L11.1063 22.0631L9.99568 21.0549ZM12.005 20.1628C11.2386 20.1628 10.508 20.4875 9.99434 21.0564L11.1077 22.0616C11.3369 21.8077 11.6629 21.6628 12.005 21.6628V20.1628ZM14.0157 21.0564C13.502 20.4875 12.7714 20.1628 12.005 20.1628V21.6628C12.3471 21.6628 12.6731 21.8077 12.9023 22.0616L14.0157 21.0564ZM14.9564 22.0971L14.0154 21.0561L12.9026 22.0619L13.8436 23.1029L14.9564 22.0971ZM16.3078 22.3941C15.838 22.5888 15.2966 22.4687 14.9532 22.0936L13.8468 23.1064C14.6163 23.9469 15.8295 24.2161 16.8822 23.7798L16.3078 22.3941ZM17.0527 21.2234C17.0754 21.7314 16.7777 22.1993 16.3078 22.3941L16.8822 23.7798C17.9349 23.3435 18.602 22.295 18.5513 21.1566L17.0527 21.2234ZM16.982 19.828L17.053 21.228L18.551 21.152L18.48 19.752L16.982 19.828ZM17.7716 17.7746C17.2295 18.3166 16.9426 19.063 16.982 19.8285L18.48 19.7515C18.4624 19.41 18.5904 19.077 18.8322 18.8352L17.7716 17.7746ZM19.8255 16.985C19.06 16.9456 18.3136 17.2325 17.7716 17.7746L18.8322 18.8352C19.074 18.5934 19.407 18.4654 19.7485 18.483L19.8255 16.985ZM21.225 17.056L19.825 16.985L19.749 18.483L21.149 18.554L21.225 17.056ZM22.4035 16.3113C22.2078 16.7838 21.7359 17.082 21.2251 17.056L21.1489 18.554C22.2933 18.6123 23.3506 17.9442 23.7893 16.8856L22.4035 16.3113ZM22.0972 14.9515C22.4766 15.2943 22.5993 15.8389 22.4035 16.3113L23.7893 16.8856C24.228 15.8269 23.9531 14.6068 23.1028 13.8385L22.0972 14.9515ZM21.0556 14.0119L22.0976 14.9519L23.1024 13.8381L22.0604 12.8981L21.0556 14.0119ZM20.1618 12.0005C20.1618 12.767 20.4864 13.4977 21.0553 14.0116L22.0607 12.8984C21.8067 12.669 21.6618 12.3428 21.6618 12.0005H20.1618ZM21.0553 9.98943C20.4864 10.5032 20.1618 11.2339 20.1618 12.0005H21.6618C21.6618 11.6582 21.8067 11.332 22.0607 11.1026L21.0553 9.98943ZM22.0976 9.04911L21.0556 9.98911L22.0604 11.1029L23.1024 10.1629L22.0976 9.04911ZM22.4037 7.69064C22.599 8.1629 22.4762 8.70692 22.0971 9.04957L23.1029 10.1624C23.9524 9.39464 24.2274 8.17565 23.7899 7.11748L22.4037 7.69064ZM21.2269 6.94509C21.7373 6.91992 22.2085 7.21839 22.4037 7.69064L23.7899 7.11748C23.3524 6.0593 22.2967 5.39052 21.1531 5.4469L21.2269 6.94509ZM19.828 7.01603L21.228 6.94503L21.152 5.44696L19.752 5.51796L19.828 7.01603ZM17.7783 6.22477C18.3187 6.76595 19.0627 7.05339 19.8266 7.0161L19.7534 5.51789C19.4127 5.53452 19.0808 5.4063 18.8397 5.16488L17.7783 6.22477ZM16.9899 4.17533C16.9515 4.93915 17.2379 5.68359 17.7783 6.22477L18.8397 5.16488C18.5987 4.92347 18.4709 4.59139 18.4881 4.25066L16.9899 4.17533ZM17.061 2.77501L16.99 4.17501L18.488 4.25098L18.559 2.85098L17.061 2.77501ZM16.3163 1.59645C16.7888 1.79222 17.087 2.26409 17.061 2.77485L18.559 2.85114C18.6173 1.7067 17.9492 0.649373 16.8906 0.210704L16.3163 1.59645ZM14.9565 1.90281C15.2993 1.52335 15.8439 1.40067 16.3163 1.59645L16.8906 0.210703C15.8319 -0.227966 14.6118 0.0469218 13.8435 0.897177L14.9565 1.90281ZM14.0083 2.94319L14.9543 1.90519L13.8457 0.8948L12.8997 1.9328L14.0083 2.94319ZM12 3.83513C12.7669 3.83513 13.4979 3.50981 14.0112 2.93999L12.8968 1.936C12.6679 2.19008 12.342 2.33513 12 2.33513V3.83513ZM12 17.251C14.8995 17.251 17.25 14.9005 17.25 12.001H15.75C15.75 14.072 14.0711 15.751 12 15.751V17.251ZM6.75 12.001C6.75 14.9005 9.10051 17.251 12 17.251V15.751C9.92893 15.751 8.25 14.072 8.25 12.001H6.75ZM12 6.75098C9.10051 6.75098 6.75 9.10148 6.75 12.001H8.25C8.25 9.92991 9.92893 8.25098 12 8.25098V6.75098ZM17.25 12.001C17.25 9.10148 14.8995 6.75098 12 6.75098V8.25098C14.0711 8.25098 15.75 9.92991 15.75 12.001H17.25Z"
              fill="#087BC4"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const plusIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9 0H7V7H0V9H7V16H9V9H16V7H9V0Z" fill={Color.secondary70} />
  </svg>
);

export const cameraIcon = (
  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 16C17.1495 16 19.5 13.6495 19.5 10.75C19.5 7.85051 17.1495 5.5 14.25 5.5C11.3505 5.5 9 7.85051 9 10.75C9 13.6495 11.3505 16 14.25 16Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 4L18.415 1.829C18.1608 1.32078 17.6412 0.99983 17.073 1H11.427C10.8588 0.99983 10.3392 1.32078 10.085 1.829L9 4H2.25C1.42157 4 0.75 4.67157 0.75 5.5V17.5C0.75 18.3284 1.42157 19 2.25 19H21.75C22.5784 19 23.25 18.3284 23.25 17.5V5.5C23.25 4.67157 22.5784 4 21.75 4H19.5Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.125 7C4.33211 7 4.5 7.16789 4.5 7.375C4.5 7.58211 4.33211 7.75 4.125 7.75C3.91789 7.75 3.75 7.58211 3.75 7.375C3.75 7.16789 3.91789 7 4.125 7"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.25 4V2.5" stroke={Color.secondary70} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const microphoneIcon = (
  <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 19.5V23.25" stroke={Color.secondary70} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect
      x="4.5"
      y="0.75"
      width="9"
      height="15.75"
      rx="3"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 9.75V12C16.5 16.1421 13.1421 19.5 9 19.5V19.5C4.85786 19.5 1.5 16.1421 1.5 12V9.75"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sendMessageIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.39962 3.74306C1.07917 3.16966 1.16907 2.45445 1.62147 1.9782C2.07388 1.50195 2.78353 1.37545 3.37262 1.66606L22.3866 11.3251C22.6382 11.453 22.7966 11.7113 22.7966 11.9936C22.7966 12.2758 22.6382 12.5341 22.3866 12.6621L3.37262 22.3341C2.78353 22.6247 2.07388 22.4982 1.62147 22.0219C1.16907 21.5457 1.07917 20.8305 1.39962 20.2571L6.45762 11.9931L1.39962 3.74306Z"
      stroke="#087BC4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22.7961 11.993H6.45215" stroke="#087BC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SentStatusIcon: React.FC<{ color?: Color }> = ({ color = Color.secondary30 }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.8716 4.83449C11.0564 4.62923 11.0397 4.31309 10.8345 4.12836C10.6292 3.94363 10.3131 3.96027 10.1284 4.16552L5.9809 8.7738L3.85355 6.64645C3.65829 6.45119 3.34171 6.45119 3.14645 6.64645C2.95118 6.84171 2.95118 7.1583 3.14645 7.35356L5.64645 9.85356C5.74344 9.95055 5.87602 10.0034 6.01314 9.99983C6.15027 9.99623 6.27989 9.93644 6.37165 9.83449L10.8716 4.83449Z"
      fill={color}
    />
  </svg>
);

export const ReceivedStatusIcon: React.FC<{ color?: Color }> = ({ color = Color.secondary30 }) => (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0635 1.70421C10.1382 1.25311 9.09868 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C9.09868 15 10.1382 14.7469 11.0635 14.2958C9.67283 13.2038 8.65291 11.661 8.22395 9.88748L7.37165 10.8345C7.27989 10.9364 7.15027 10.9962 7.01314 10.9998C6.87602 11.0034 6.74344 10.9506 6.64645 10.8536L4.14645 8.35356C3.95118 8.1583 3.95118 7.84171 4.14645 7.64645C4.34171 7.45119 4.65829 7.45119 4.85355 7.64645L6.9809 9.7738L8.02333 8.61555C8.00787 8.41239 8 8.20712 8 8C8 5.44448 9.19825 3.16882 11.0635 1.70421Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 15C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1C12.134 1 9 4.13401 9 8C9 11.866 12.134 15 16 15ZM19.8716 5.83449C20.0564 5.62923 20.0397 5.31309 19.8345 5.12836C19.6292 4.94363 19.3131 4.96027 19.1284 5.16552L14.9809 9.7738L12.8536 7.64645C12.6583 7.45119 12.3417 7.45119 12.1464 7.64645C11.9512 7.84171 11.9512 8.1583 12.1464 8.35356L14.6464 10.8536C14.7434 10.9506 14.876 11.0034 15.0131 10.9998C15.1503 10.9962 15.2799 10.9364 15.3716 10.8345L19.8716 5.83449Z"
      fill={color}
    />
  </svg>
);

export const readStatusIcon = (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0635 1.70421C10.1382 1.25311 9.09868 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C9.09868 15 10.1382 14.7469 11.0635 14.2958C9.67283 13.2038 8.65291 11.661 8.22395 9.88748L7.37165 10.8345C7.27989 10.9364 7.15027 10.9962 7.01314 10.9998C6.87602 11.0034 6.74344 10.9506 6.64645 10.8536L4.14645 8.35356C3.95118 8.1583 3.95118 7.84171 4.14645 7.64645C4.34171 7.45119 4.65829 7.45119 4.85355 7.64645L6.9809 9.7738L8.02333 8.61555C8.00787 8.41239 8 8.20712 8 8C8 5.44448 9.19825 3.16882 11.0635 1.70421Z"
      fill={Color.statusGreen}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 15C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1C12.134 1 9 4.13401 9 8C9 11.866 12.134 15 16 15ZM19.8716 5.83449C20.0564 5.62923 20.0397 5.31309 19.8345 5.12836C19.6292 4.94363 19.3131 4.96027 19.1284 5.16552L14.9809 9.7738L12.8536 7.64645C12.6583 7.45119 12.3417 7.45119 12.1464 7.64645C11.9512 7.84171 11.9512 8.1583 12.1464 8.35356L14.6464 10.8536C14.7434 10.9506 14.876 11.0034 15.0131 10.9998C15.1503 10.9962 15.2799 10.9364 15.3716 10.8345L19.8716 5.83449Z"
      fill={Color.statusGreen}
    />
  </svg>
);

export const backIcon = (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 2.10264L8.48721 -1.11296e-06L1.18021e-06 9L8.48721 18L10.5 15.8974L4.02558 9L10.5 2.10264Z"
      fill="white"
    />
  </svg>
);

export const phoneIcon = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0398 22.39L15.0518 22.397C17.2398 23.79 20.1018 23.4761 21.9358 21.642L22.7098 20.868C23.4296 20.1473 23.4296 18.9797 22.7098 18.259L19.4488 15C18.7281 14.2802 17.5605 14.2802 16.8398 15V15C16.4941 15.3461 16.025 15.5406 15.5358 15.5406C15.0466 15.5406 14.5775 15.3461 14.2318 15L9.01381 9.78099C8.294 9.06027 8.294 7.89271 9.01381 7.17199V7.17199C9.35993 6.8263 9.55442 6.35718 9.55442 5.86799C9.55442 5.37881 9.35993 4.90969 9.01381 4.56399L5.75381 1.29999C5.03309 0.580178 3.86553 0.580178 3.14481 1.29999L2.37081 2.07399C0.537098 3.90814 0.222852 6.76961 1.61481 8.95799L1.62281 8.96999C5.19623 14.2598 9.75079 18.8154 15.0398 22.39V22.39Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const familyIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 8.25C5.74264 8.25 6.75 7.24264 6.75 6C6.75 4.75736 5.74264 3.75 4.5 3.75C3.25736 3.75 2.25 4.75736 2.25 6C2.25 7.24264 3.25736 8.25 4.5 8.25Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 9.75C2.42893 9.75 0.75 11.4289 0.75 13.5V15.75H2.25L3 21.75H6"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 8.25C20.7426 8.25 21.75 7.24264 21.75 6C21.75 4.75736 20.7426 3.75 19.5 3.75C18.2574 3.75 17.25 4.75736 17.25 6C17.25 7.24264 18.2574 8.25 19.5 8.25Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 9.75C21.5711 9.75 23.25 11.4289 23.25 13.5V15.75H21.75L21 21.75H18"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.75C13.6569 6.75 15 5.40685 15 3.75C15 2.09315 13.6569 0.75 12 0.75C10.3431 0.75 9 2.09315 9 3.75C9 5.40685 10.3431 6.75 12 6.75Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 13.5C17.25 10.6005 14.8995 8.25 12 8.25C9.10051 8.25 6.75 10.6005 6.75 13.5V15.75H9L9.75 23.25H14.25L15 15.75H17.25V13.5Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const addMemberIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
      stroke="#087BC4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17.25 14.25V20.25" stroke="#087BC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.25 17.25H20.25" stroke="#087BC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M0.75 17.25C0.751544 14.9834 1.89011 12.8687 3.78149 11.6196C5.67287 10.3705 8.06476 10.1536 10.15 11.042"
      stroke="#087BC4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9C9.77817 9 11.625 7.15317 11.625 4.875C11.625 2.59683 9.77817 0.75 7.5 0.75C5.22183 0.75 3.375 2.59683 3.375 4.875C3.375 7.15317 5.22183 9 7.5 9Z"
      stroke="#087BC4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const closeIcon = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.40176L10.5982 0L6 4.59824L1.40176 0L0 1.40176L4.59824 6L0 10.5982L1.40176 12L6 7.40176L10.5982 12L12 10.5982L7.40176 6L12 1.40176Z"
      fill="#767B84"
    />
  </svg>
);

export const imagesIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.75"
      y="0.75"
      width="22.5"
      height="22.5"
      rx="1.5"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 17.25L8.712 12.634C8.97285 12.286 9.37191 12.0683 9.80575 12.0374C10.2396 12.0065 10.6655 12.1654 10.973 12.473L12 13.5L15.3 9.1C15.5833 8.72229 16.0279 8.5 16.5 8.5C16.9721 8.5 17.4167 8.72229 17.7 9.1L20.37 12.66"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.375 8.25C7.41053 8.25 8.25 7.41053 8.25 6.375C8.25 5.33947 7.41053 4.5 6.375 4.5C5.33947 4.5 4.5 5.33947 4.5 6.375C4.5 7.41053 5.33947 8.25 6.375 8.25Z"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 17.25H23.25"
      stroke={Color.secondary70}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const videoCameraIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.75"
      y="5.26099"
      width="15"
      height="13.5"
      rx="3"
      stroke={Color.primary}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 15.011L22.165 16.718C22.3975 16.8341 22.6735 16.8215 22.8945 16.6848C23.1155 16.5482 23.25 16.3068 23.25 16.047V7.97399C23.2502 7.71409 23.1157 7.47266 22.8945 7.33611C22.6734 7.19956 22.3973 7.1874 22.165 7.30399L18.75 9.01099"
      stroke={Color.primary}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
